export default __webpack_public_path__ + "static/media/Sepasoft.d16ed6ef.png";